import { registerMessages } from "../../../i18n/runtime";

export const protectEn = {
  "protect.title": "UniFi Protect cameras",
  "protect.setupHint": "Connect the club’s Protect console, discover cameras, then choose which feeds staff may add to their dashboards. Staff also need the camera viewing permission.",
  "protect.origin": "Console HTTPS address",
  "protect.originHint": "Use an address reachable from the ClubCore server, with a trusted HTTPS certificate.",
  "protect.prefix": "Console API path",
  "protect.proxy": "UniFi OS console",
  "protect.direct": "Direct Protect application",
  "protect.host": "Stream NVR host",
  "protect.hostHint": "Leave blank to use the console hostname. Set this only when Protect returns a different NVR hostname.",
  "protect.key": "Protect Integration API key",
  "protect.keyHint": "Write-only and encrypted. Leave blank to keep the saved key. Use a dedicated account limited to the intended cameras.",
  "protect.keySaved": "An API key is saved.",
  "protect.enabled": "Enable camera viewing",
  "protect.save": "Save camera connection",
  "protect.saved": "Camera connection saved.",
  "protect.discover": "Test connection and discover cameras",
  "protect.discovered": "Camera inventory refreshed. New cameras stay private until published.",
  "protect.empty": "No cameras discovered yet.",
  "protect.publish": "Allow dashboard viewing of {name}",
  "protect.status.connected": "Connected",
  "protect.status.connecting": "Connecting",
  "protect.status.offline": "Offline",
  "protect.published": "Available to staff with camera viewing permission",
  "protect.cameraLabel": "Camera · {name}",
  "protect.editorHint": "Choose published cameras below. Your camera selection and arrangement are saved only for your account at this club.",
  "protect.frontGate": "Use front-gate layout",
  "protect.frontGateTitle": "Front gate",
  "protect.frontGateHint": "Camera views and arrivals, together in your gate workspace.",
  "protect.workspace": "Use standard workspace",
  "protect.noCameras": "No published cameras are available. Ask an administrator to connect Protect and publish the gate camera in Club Settings.",
  "protect.connecting": "Connecting to camera…",
  "protect.live": "Live",
  "protect.paused": "Paused",
  "protect.delay": "Live video has a short delay. Audio is off.",
  "protect.retry": "Reconnect camera",
  "protect.pause": "Pause camera",
  "protect.resume": "Resume camera",
  "protect.unavailable": "Camera playback stopped. Reconnect, or ask an administrator to check Protect and the server relay.",
  "protect.unsupported": "This browser does not support secure dashboard video. Open the dashboard in a current Chrome, Edge or Safari browser.",
  "protect.video": "Live video from {name}",
} as const;

export type ProtectMessages = typeof protectEn;
export const protectEs: Record<keyof ProtectMessages, string> = {
  "protect.title": "Cámaras UniFi Protect",
  "protect.setupHint": "Conecte la consola Protect del club, descubra cámaras y elija qué transmisiones puede añadir el personal a sus paneles. El personal también necesita permiso para ver cámaras.",
  "protect.origin": "Dirección HTTPS de la consola",
  "protect.originHint": "Use una dirección accesible desde el servidor ClubCore con un certificado HTTPS de confianza.",
  "protect.prefix": "Ruta API de la consola",
  "protect.proxy": "Consola UniFi OS",
  "protect.direct": "Aplicación Protect directa",
  "protect.host": "Host NVR de transmisión",
  "protect.hostHint": "Déjelo vacío para usar el host de la consola. Cámbielo solo si Protect devuelve otro host NVR.",
  "protect.key": "Clave API de integración Protect",
  "protect.keyHint": "Cifrada y solo de escritura. Déjela vacía para conservar la clave. Use una cuenta dedicada limitada a las cámaras previstas.",
  "protect.keySaved": "Hay una clave API guardada.",
  "protect.enabled": "Activar visualización de cámaras",
  "protect.save": "Guardar conexión de cámaras",
  "protect.saved": "Conexión de cámaras guardada.",
  "protect.discover": "Probar conexión y descubrir cámaras",
  "protect.discovered": "Inventario actualizado. Las cámaras nuevas son privadas hasta publicarlas.",
  "protect.empty": "Todavía no se han descubierto cámaras.",
  "protect.publish": "Permitir visualización de {name} en paneles",
  "protect.status.connected": "Conectada",
  "protect.status.connecting": "Conectando",
  "protect.status.offline": "Desconectada",
  "protect.published": "Disponible para personal con permiso de cámaras",
  "protect.cameraLabel": "Cámara · {name}",
  "protect.editorHint": "Elija las cámaras publicadas. La selección y el orden se guardan solo para su cuenta en este club.",
  "protect.frontGate": "Usar diseño de entrada",
  "protect.frontGateTitle": "Entrada principal",
  "protect.frontGateHint": "Cámaras y llegadas, juntas en su espacio de entrada.",
  "protect.workspace": "Usar espacio estándar",
  "protect.noCameras": "No hay cámaras publicadas. Pida a un administrador que conecte Protect y publique la cámara en Ajustes del club.",
  "protect.connecting": "Conectando con la cámara…",
  "protect.live": "En vivo",
  "protect.paused": "En pausa",
  "protect.delay": "El video tiene un pequeño retraso. Audio desactivado.",
  "protect.retry": "Reconectar cámara",
  "protect.pause": "Pausar cámara",
  "protect.resume": "Reanudar cámara",
  "protect.unavailable": "La reproducción se detuvo. Reconecte o pida que revisen Protect y la retransmisión del servidor.",
  "protect.unsupported": "Este navegador no admite video seguro. Abra el panel en Chrome, Edge o Safari actualizado.",
  "protect.video": "Video en vivo de {name}",
};

registerMessages("en", protectEn);
registerMessages("es", protectEs);
